import { create } from "zustand";

export type HeaderDropdownType = "notifications" | "downloads" | "help" | null;

interface HeaderDropdownState {
  activeDropdown: HeaderDropdownType;
}

interface HeaderDropdownActions {
  setActiveDropdown: (dropdown: HeaderDropdownType) => void;
  openDropdown: (dropdown: Exclude<HeaderDropdownType, null>) => void;
  closeDropdown: () => void;
}

export const useHeaderDropdownStore = create<
  HeaderDropdownState & HeaderDropdownActions
>()((set) => ({
  activeDropdown: null,
  setActiveDropdown: (dropdown) => set({ activeDropdown: dropdown }),
  openDropdown: (dropdown) => set({ activeDropdown: dropdown }),
  closeDropdown: () => set({ activeDropdown: null }),
}));
